<div *ngIf="beforeTemplate" class="beforeItem">
	<ng-container *ngTemplateOutlet="beforeTemplate"></ng-container>
</div>

<div *ngIf="button.themeColor?.light" class="beforeItem rectangle" [style.background]="button.themeColor.light"></div>
<!--<div *ngIf="button.themeColor?.light" class="beforeItem circle" [style.background]="button.themeColor.light"></div>-->

<a class="iconCell" [href]="button.downloadOptions.downloadUrl"
   [download]="button.downloadOptions.downloadFileName"
   *ngIf="button.downloadOptions!==undefined else nonDownload">
	<i class="{{button.iconClass}}"></i>
</a>

<ng-template #nonDownload>
	<div class="iconCell" *ngIf="button.iconClass && button.iconClass !== ''"><i class="{{button.iconClass}}"></i></div>
	<div class="titleCell" *ngIf="(button.titleToTranslate && button.titleToTranslate.template && button.titleToTranslate.template !== '') || (button.titlePlain && button.titlePlain !== '')">
		<div class="titleOuter">
			<div class="titleInner"
				 [ngClass]="{'singleClass' : button.isSelected}"
				 [style.color]="button.isSelected ? undefined : button.themeColor?.light"
			     [title]="button.tooltipPlain ? button.tooltipPlain : button.tooltipToTranslate ? (tooltipToTranslate.template | cpActionTranslate: tooltipToTranslate.params) : ''">
				{{button.titlePlain ? button.titlePlain : button.titleToTranslate.template | cpActionTranslate: button.titleToTranslate.params}}
			</div>
		</div>
	</div>
</ng-template>

<div *ngIf="afterTemplate" class="afterItem">
	<ng-container *ngTemplateOutlet="afterTemplate"></ng-container>
</div>
